<script lang="ts">
    import {onMount} from "svelte";
    import {slide} from 'svelte/transition';
    import type {IUser} from "$lib/interfaces/IUserMe";
    import FatArrowRight from "$lib/icons/FatArrowRight.svelte";
    import type {ILevelResponse} from "$lib/interfaces/ILevel";
    import {userService} from "$lib/services/user.service";
    import {locale, translate} from "$lib/i18n";
    import WalletIcon from "$lib/icons/WalletIcon.svelte";
    import LevelUpIcon from "$lib/icons/LevelUpIcon.svelte";
    import LogOutIcon from "$lib/icons/LogOutIcon.svelte";
    import PromotionsIcon from "$lib/icons/PromotionsIcon.svelte";
    import {deleteCookie} from "$lib/utils/cookies";
    import {goto} from "$app/navigation";
    import ProfileIcon from "$lib/icons/ProfileIcon.svelte";
    import {myLevel, OverlayLoaderShow, user, userReducer} from "$lib/stores";
    import {openDialog} from "$lib/stores/dialogStores";

    let isOpen = $state(false);
    let dropdownRef: HTMLDivElement = $state();
    interface Props {
        localUser: IUser;
    }

    let { localUser }: Props = $props();
    let level: ILevelResponse = $state();

    function toggleDropdown() {
        isOpen = !isOpen;
    }

    function handleClickOutside(event: MouseEvent) {
        if (dropdownRef && !dropdownRef.contains(event.target as Node)) {
            isOpen = false;
        }
    }

    function getLevel() {
        userService.getLevel().then((response: any) => {
            if (response) {
                return response.data;
            }
            throw new Error('Failed to fetch level');
        }).then(data => {
            level = data.data;
            myLevel.set(level);
        }).catch(err => {
            console.error(err);
        });
    }

    onMount(() => {
        getLevel();
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    });

    function logout() {
      OverlayLoaderShow.set(true);
      userService.logout().then((res) => {
        deleteCookie('forza_token')
        userReducer(null);
        goto(`/${$locale}`).then(() => {
          window.location.reload();
        });
      });
    }
</script>


<div class="relative" bind:this={dropdownRef}>
    <button onclick={toggleDropdown}
            class="flex items-center justify-center text-sm focus:outline-none rounded-full w-8 h-8 md:w-10 md:h-10 bg-primary-blue border border-primary-lightBlue text-white">
        {localUser.username[0].toUpperCase()}
    </button>

    {#if isOpen}
        <div transition:slide|local={{ duration: 300, axis: 'y' }}
             class="rotate absolute right-0 w-80 mt-4 origin-top-right rounded-lg shadow-lg focus:outline-none bg-primary-dark p-4">
          <a href="/{$locale}/profile/account-details" onclick={() => isOpen = false}>
          <div class="flex items-center justify-between px-3 py-2 bg-gradient-to-br bg-fire rounded-xl pb-2 cursor-pointer">
                <div class="flex items-center gap-2">
                    <div class="bg-primary-blue rounded-full w-16 h-16 flex items-center justify-center text-lg text-white">
                        {localUser.username.slice(0, 2).toUpperCase()}
                    </div>
                    <div>
                        <div class="text-white">{localUser.username}</div>
                        <div class="text-white text-xs">{localUser.email}</div>
                    </div>
                </div>
                <FatArrowRight/>
            </div>
          </a>
          <div class="h-[1px] w-full bg-primary-lightBlue my-4"></div>
            {#if level}
                <div class="px-3 py-2 border-[2px] border-primary-blue rounded-xl text-white">
                    <span class="text-sm">{$translate('Your Rank:')} {level.level.name}</span>
                    <div class="mt-2">
                        <div class="flex items-center relative">
                            <div class="bg-primary-lightBlue w-full rounded-full h-4 overflow-hidden text-lg text-white">
                                <div style="width: {level.progressPercentageToNextLevel}%" class="h-4 px-2.5 rounded-full flex justify-center bg-primary-fire text-xs">{level.progressPercentageToNextLevel}%</div>
                            </div>
                            <div class="absolute -right-4 bg-primary-blue border border-primary-fire/60 rounded-full">
                                <img src="/level-up/icons/{level.level.number}.png" class="w-10 " alt="">
                            </div>
                        </div>
                    </div>
                </div>
            {/if  }
            <div class="h-[1px] w-full bg-primary-lightBlue my-4"></div>
            <button disabled={localUser.selfExcluded} onclick={() => {isOpen = false; openDialog('DepositModal')}} class="flex my-4 px-2 w-full">
                <WalletIcon/>
                <span class="text-white ml-3">{$translate('Wallet')}</span>
            </button>
            <a href="/{$locale}/profile/account-details" onclick={() => isOpen = false} class="flex my-4 px-2">
                <ProfileIcon/>
                <span class="text-white ml-3">{$translate('Profile')}</span>
            </a>
            <a href="/{$locale}/bonus" onclick={() => isOpen = false} class="flex my-4 px-2">
                <PromotionsIcon/>
                <span class="text-white ml-3">{$translate('Bonus')}</span>
            </a>
            <a href="/{$locale}/level-up" onclick={() => isOpen = false} class="flex my-4 px-2">
                <LevelUpIcon/>
                <span class="text-white ml-3">{$translate('Level Up')}</span>
            </a>


            <div class="h-[1px] w-full bg-primary-lightBlue my-4"></div>
            <button class="flex my-3.5 px-2" onclick={() => logout()}>
                <LogOutIcon/>
                <span class="text-white ml-3">{$translate('Logout')}</span>
            </button>
        </div>
    {/if}
</div>
